import { media } from "../assets/media";

/*
  Each project can have a `content` array that defines its detail page —
  mix plain strings (paragraphs) and media in any order, top to bottom:

  content: [
    "Intro paragraph...",
    media.someimage,
    "Text under the image...",
    { src: media.otherimage, width: "40%" },   // optional custom width
    { src: media.somevideo, controls: true },  // video player with sound
  ],

  New images: put the file in src/images, import it in media.js, then
  reference it here — that also gets it preloaded on app start.
  Projects without `content` fall back to showing their hover media.
*/

export const projects = [
  {
    id: 1,
    title: "CRESCENT",
    description: "Website",
    technologies: "React, Vite",
    link: "https://crescent-project.onrender.com",
    year: 2026,
    mediaFiles: [
      media.crescentweblanding,
      media.crescentwebcastle,
      media.crescentwebvideo,
    ],
    content: [
      "Website. Brand identity by me. *No AI used in any part of the design process",
      media.crescentweblanding,
      media.crescentwebcastle,
      media.crescentwebvideo,
    ],
  },
  {
    id: 2,
    title: "CRESCENT",
    description: "Brand Identity",
    type: "Branding",
    technologies: "Adobe Illustrator, Adobe Photoshop, Adobe After Effects",
    year: 2026,
    mediaFiles: [media.crescentHero, media.crescentFonts, media.crescentPoster],
    content: [
      "CRESCENT is a conceptual music venue in Latvia dedicated to giving underground music a real platform to be heard, experienced, and shared. Its identity blends local cultural symbolism with a forward-looking spirit, creating a space where emerging artists, alternative sounds, and new scenes can grow and come into the light. *No AI used in any part of the design process",
      media.crescentHero,
      "Latvian signs Latvian signs are old geometric folk symbols from pre-Christian Baltic tradition, used to represent natural forces, deities, and ideaslike protection, fertility, luck, and harmony.",
      "They come from ancient Latvian ornament and mythology and were placedon clothing, tools, homes, and jewelry because people believed the signscarried meaning and protective power in daily life.",
      "The Cross of The Moon",
      "The moon is seen as a paternal figure in Latvian folklore.This sign is relatedto agriculture, growth and disasters. Also seen as a symbol of protection forsoldiers and was often found sewn on battle uniforms.",
      { src: media.crescentCross, width: "20%" },
      media.crescentProcess,
      "The hardest part for creation of the logo was choosing the right starting font. My goal was toachieve a timeless look while still maintaining an alternative image of the brand. Thisbalance was hard to find - the top right logo seen in the screenshot below is alternative yetnot timeless in my opinion, and the geometric on the middle and far right side is notalternative enough yet timeless. Therefore, I ended up going with the serif font, which Ibelieve is both timeless and interesting/unique. The word CRESCENT, also is perfecetlysimetric, allowing for both E’s to be evenly in the middle.",
      media.crescentLogo,
      media.crescentLogoVariant,
      // rest
      { src: media.crescentFonts, width: "50%" },
      "The goal for these chosen fonts was that they should be able to work well together and bedistinctive from each other. Archivo Black Regular was selected due to its boldness; its goalis to attract attention, so it is used for headings and titles. Cardo Regular works well forrunning text and smaller details; lastly, Archivo Narrow Bold is used to provide more detailsin the composition. As this is a Latvian brand, a key aspect was also that these fonts workwell with the Latvian alphabet, such as ā,č,ğ, etc.",
      "The idea for these colors was similar to fonts - they must work well together and providecontrast. It was a deliberate decision to use True black and True white as they strike morecontrast. The hardest part for the color palette was to keep it minimal yet bold. Therefore,the chosen colours all work well with each other and work in different combinations as theyall have a big contrast with each other.",
      { src: media.crescentPoster, width: "50%" },
      "My goal for the print collateral was to convey moreof a feeling and an aesthetic of the brand ratherthan be informative. The print consists of twoheavily edited (Brightness, contrast, color andvibrance, clarity, dehaze, curves, color balance)images in the background, a cropped image on topand my logo symbol with a layer mode ofexclusion. To achieve the final look, it took me alot of just playing around and seeing what worksand what doesn’t - a lot of experimenting withdifferent adjustments and layer modes.",
    ],
  },
  {
    id: 3,
    title: "THR33",
    description: "Website",
    technologies: "Vue, Vite",
    link: "https://three-project-0cpe.onrender.com",
    year: 2026,
    mediaFiles: [media.threelanding, media.threedrinks, media.threevideo],
    content: [
      "Website for client. Brand identity by Martina Tommola. *No AI used in any part of the design process",
      media.threelanding,
      media.threedrinks,
      media.threevideo,
    ],
  },
  {
    id: 4,
    title: "Anete",
    description: "Identity & Website",
    type: "Frontend Development, UI/UX Design",
    technologies: "Typescript, NextJS, Sanity CMS",
    link: "https://anete-portfolio.onrender.com",
    year: 2026,
    mediaFiles: [media.anetelanding, media.aneteprojects, media.aneteportvideo],
    content: [
      "*No AI used in any part of the design process",
      media.anetelanding,
      media.aneteprojects,
      media.aneteportvideo,
    ],
  },
  {
    id: 5,
    title: "EWG",
    description: "UI/UX Design",
    type: "UI/UX",
    technologies: "Figma",
    year: 2024,
    mediaFiles: [media.ewgarticles, media.ewgdonate, media.ewgvideo],
    content: [
      "When redesigning the website the focus was largely drawn on the transitions between the sections, improving the User Experience and tone of the website and just easier navigation throughout the website overall I achieved this by using many illustrations when transitioning between sections, splitting or combining existing sections, such as splitting the Consumer Guides section into tools and informative articles, referencing to the website traffic (link), using a more friendly font to lighten up the tone of the website, used a small colour palette to create a coherent design, used font sizes to create a clearer visual hierarchy, shift focus and more. *No AI used in any part of the design process",
      media.ewglandingpr,
      media.ewgarticlespr,
      media.ewgdonatepr,
      media.ewgnewspr,
      "Consumer Guides on EWG’s website provides informative articles and websites which act as tools for users to search for EWG verified products. I split these two into two different sections for easier User Experience interaction.",
      { src: media.ewgtrafficpr, width: "40%" },
      "For example, a lot of the organic user traffic goes to the keyword “ewg skin deep”, though on their website, especially mobile version, it is in their fourth slide, by providing all of the tools in a single section, improves the user navigation and may even draw more attention and traffic to the other less known tools that EWG provides.",
    ],
  },
  // Hidden for now — uncomment (and its imports in media.js) to bring back.
  /*
  {
    id: 9,
    title: "Video",
    description: "Product Launch",
    type: "Motion Graphics, Video Editing",
    technologies: "Adobe After Effects",
    year: 2024,
    mediaFiles: [null, null, media.motionvideoshort],
    content: [
      "*No AI used in any part of the design process",
      { src: media.motionvideo, controls: true },
    ],
  },
  */
  {
    id: 6,
    title: "Street Culture",
    description: "Print",
    type: "Print",
    technologies: "Adobe InDesign, Adobe Illustrator, Adobe Photoshop",
    year: 2024,
    mediaFiles: [media.cover, media.streetcultback, media.streetcultvideo],
    content: [
      "Made in collaboration with Anastasija Zalomajeva & Anna Kubisova. *No AI used in any part of the design process",
      media.skatemag1,
      media.skatemag2,
      media.skatemag3,
      media.skatemag4,
      { src: media.cover, width: "40%" },
      { src: media.streetcultback, width: "40%" },
      { src: media.streetcultvideo, width: "50%" },
    ],
  },
  // Hidden for now — uncomment (and its imports in media.js) to bring back.
  /*
  {
    id: 10,
    title: "BOOMBOX",
    description: "Music Sharing Platform",
    type: "Full-Stack Development, UI/UX Design",
    technologies: "Express, NodeJS, SQLite",
    year: 2024,
    mediaFiles: [media.boomboxhome, media.boomboxhsongs, media.boomboxvideo],
    content: [
      "*No AI used in any part of the design process",
      media.boomboxhome,
      media.boomboxhsongs,
      media.boomboxvideo,
    ],
  },
  */
  {
    id: 7,
    title: "Personal",
    description: "Identity",
    type: "Branding",
    technologies: "Adobe Illustrator, Adobe Photoshop, Figma",
    year: 2024,
    mediaFiles: [
      media.brandinglogos,
      media.brandingtypograpgy,
      media.brandingvideo,
    ],
    content: [
      "*No AI used in any part of the design process",
      media.brandinglogos,
      media.brandingtypograpgy,
      media.brandingvideo,
    ],
  },
  {
    id: 8,
    title: "Studly",
    description: "UI/UX Design",
    type: "UI/UX",
    technologies: "Figma",
    year: 2023,
    mediaFiles: [media.studlylanding, media.studlyfooter, media.studylvideo],
    content: [
      "*No AI used in any part of the design process",
      media.studlylanding,
      media.studlyfooter,
      media.studylvideo,
    ],
  },
  // Hidden for now — uncomment (and its imports in media.js) to bring back.
  /*
  {
    id: 11,
    title: "Verbum",
    description: "Language Learning App",
    type: "Full-Stack Development, UI/UX Design",
    technologies:
      "React, NodeJS, Express, MongoDB, Axios, Mongoose, Jsonwebtoken, Bcrypt, Redux, Filestack",
    link: "https://github.com/ReinisMuiznieks/Verbum",
    year: 2023,
    mediaFiles: [media.verbumcard, media.verbumhistory, media.verbumproject],
    content: [
      "Starting on February 24, 2022, Russia began a military aggression against Ukraine. Since then, millions of people have fled the war, seeking refuge in EU countries, including Latvia. The war started by Russia has forced millions of Ukrainian residents, including Ukrainian children, to become refugees. Latvia also accepts war refugees, and according to a government-approved plan, Latvia intends to provide support to a total of up to 40,000 Ukrainian civilians. As Ukraine regains its territories, some refugees are already returning home, but most will have to stay here for a long time even after the war ends, because their homes have been destroyed and infrastructure ruined. In Latvia, much thought is being given to how to better integrate these people into society – one of the key success factors is language. Many Ukrainians have already, within a couple of months, learned Latvian through self-study, but for older people or school-age children this is not always easy. This gave rise to the idea of creating a Latvian language learning system to give foreign nationals and diaspora Latvians the opportunity to learn Latvian through self-study. The system will initially provide A1-level Latvian language learning in the form of flashcards and tests. Users will be able to study the given flashcards and then take tests to check their acquired knowledge.",
      "To implement the system as a modern, efficient, and sustainable solution, the latest technical tools were used in its development. The system is based on MERN technologies – MongoDB, Express, React, Node. Programming languages were used as the foundation of these technologies, along with corresponding auxiliary programs that ensure efficient debugging.",
      "Various modules were also applied and adopted, which unequivocally speed up the development process, security, and performance. As the system develops, the number of adopted modules will likely increase further, but for now these are among the most significant adopted modules.",
      "*No AI used in any part of the design process",
      media.verbumregistration,
      "Registration Data Flow Diagram",
      "Creating a user profile is one of the main components of the site's functionality, since all further user experience is tied to a registered user. User registration – profile creation – proceeds as follows. First, it is checked whether the user is already logged into the system. If the user is logged in (has an active session), the user is redirected to the home page, since a registered user has no need to register. Once it has been verified that the user is not currently logged in, it is checked whether the entered username consists of at least 3 characters and fewer than 12 characters. If the user has entered a name that does not meet these conditions, an error is displayed on the screen explaining this form's requirements.",
      "Next, it is checked whether the entered user email matches the form requirements. It is checked whether the email contains an '@' symbol and a '.' symbol, and whether there is at least one character before and after the '@'', and at least two characters after the dot. If the entered user email does not meet these conditions, an error is displayed on the screen explaining this form's requirements.",
      "Then the first entered password is checked. Initially, it checks whether the entered password contains at least 6 characters. If the entered password does not meet this condition, an error is displayed on the screen explaining this form's requirement.",
      "If the user's entered password meets the previous conditions, it is then checked whether this password contains at least 1 uppercase letter. If the entered password does not meet this condition, an error is displayed on the screen explaining this form's requirement.",
      "Once all password form conditions are met, it is checked whether the second password, i.e., the repeated first password, matches the first password. If the entered repeated password does not match the first password, an error is displayed on the screen explaining this form's requirement.",
      "Once all fields are successfully filled in, it is checked whether the entered email address already exists in the database. If a user with this email already exists, an error is displayed on the screen explaining this error.",
      "If registration is successful, the user is redirected to the home page, and the user's email and password, which is encrypted, are saved in the database.",
      media.verbumcardcreation,
      "Flashcard Creation Data Flow Diagram",
      "In the flashcard creation data flow diagram, it is first checked whether the user is already logged into the system. If the user is not logged in (does not have an active session), the user is redirected to the home page, since they lack authorization.",
      "Next, it is checked whether the user has the administrator role. If the user does not have this role, they lack authorization.",
      "Once the authorization check has passed, the fields are checked, starting with the Latvian word form. If the field is not filled in, an error is displayed on the screen explaining this form's requirements.",
      "Next, the English word form is checked. If the field is not filled in, an error is displayed on the screen explaining this form's requirements",
      "Next, it is checked whether a category has been selected. If no category is selected, an error is displayed on the screen explaining this form's requirements.",
      "Next, it is checked whether an image has been selected. If the field is not filled in, an error is displayed on the screen explaining this form's requirements.",
      "If an image has been successfully selected, various conditions are checked to verify that the image meets the requirements. If the image does not meet the requirements, a corresponding error is displayed on the screen explaining the reason for the error.",
      "Next, it is checked whether an audio file has been selected. If the field is not filled in, an error is displayed on the screen explaining this form's requirements.",
      "If audio has been successfully selected, various conditions are checked to verify that the audio meets the requirements. If the audio does not meet the requirements, a corresponding error is displayed on the screen explaining the reason for the error.",
      "Finally, if the form has been successfully filled in, the given data is saved in the database in the corresponding table.",
      "System Architecture",
      "For the Latvian language learning system, the following functional system diagram is implemented, consisting of 3 subsystems: the guest subsystem, the user subsystem, and the administrator subsystem. Since the site's main functionality is learning Latvian, the set of actions is offered to users who have registered in the system. The site consists of the following systems",
      media.verbumstructure,
      "Guest system – mostly provides only an informational overview of the site and does not offer any special capabilities. The guest system consists of the following modules and permissions within them.",
      "Module 'Registration': the user can create an account. When creating an account, the entered form data is validated.",
      "Module 'Authorization': the user can log in. During login, the entered form data is checked, as well as verification of the session key.",
      "User system – one of the main systems on the site, as it is granted immediately after successful user registration.",
      "Module 'User Profile': the user can view their profile and is given the option to log out of the system.",
      "Module 'Categories': the user can view the available categories.",
      "Module 'Flashcards': the user can view the available flashcards.",
      "Module 'Tests': the user can view and take the available tests.",
      "Module 'Questions': the user can view and select an answer to the available questions in a test.",
      "Administrator system – the most privileged system.",
      "Module 'User Profile': the administrator can view their profile, edit it, and is given the option to log out of the system.",
      "Module 'Users': the administrator can view all users, edit their roles, and delete them.",
      "Module 'Categories': the administrator can view the available categories, edit, delete, or add them.",
      "Module 'Flashcards': the administrator can view the available flashcards, edit, delete, or add them.",
      "Module 'Tests': the administrator can view and take the available tests, edit, delete, or add them.",
      "Module 'Questions': the administrator can view, edit, delete, or add questions, as well as select an answer to the available questions in a test.",
      media.verbumer,
      "The ER diagram of the system model consists of five tables containing information about users, tests, test questions, flashcards, and categories. Users consist of a username, password, email address, and the user's password. A test consists of its name. When a user takes a test, a result, the user's incorrect answers, and the date the test was taken are obtained. A question contains the question itself, the options, the correctness of each option, and an image. A category contains its name. A flashcard contains the word in Latvian, the word in English, an image, and audio. As users study the flashcards, this results in obtaining progress and a status. During system development, many-to-many relationship links will be created between the tables that form such relations.",
      media.verbumdb,
      "DATA STRUCTURE DESCRIPTION",
      "The database developed within the framework of the qualification thesis consists of 7 tables. The tables contain information about users, flashcards, tests, questions, categories, tests taken by users, and categories learned by users. The Latvian language learning system is based on the database structure plan.",
      media.verbumcard,
      media.verbumhistory,
      media.verbumproject,
    ],
  },
  */
];
